module.exports = "<div>\n    <div class=\"highcharts\" #chart></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/highcharts/highcharts.component.html
// module id = ../../../../../src/app/components/highcharts/highcharts.component.html
// module chunks = main